import React, { Component } from "react";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar.js";
import Select from "react-select";
import Pagination from "@mui/material/Pagination";
import { tokens, select_style, toFixed, GET, format_date, getStorage, loading } from "../../components/CustomComponent.js";

const select_role = getStorage("role_detail")?.find((item) => item.name === "record-water-usage")?.role || [];
const view_r = select_role[0] === 1;

export default class WaterUsageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      filter_address_number: null,
      data: null,
      data_address: [], // ป้องกัน Select error
    };
  }

  async componentDidMount() {
    loading(false); // สั่งปิดโหลดตั้งแต่เริ่มเข้าหน้าแรก
    if (view_r) await this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    const { filter_address_number, page } = this.state;
    const payload = { address_number: filter_address_number?.value || "" };
    
    const result = await GET(tokens, `v1/TH/record-other/filter-search/page/${page}/${getStorage("project_id")}`, payload);
    if (result?.status) {
      this.setState({ data: result.data });
    }
    loading(false);
  };

  printReceipt = (item) => {
    const data_print = {
      project_name: getStorage("project_name"),
      project_address: `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`,
      cutomer_name: item.full_name,
      cutomer_address: item.address || item.address_number,
      number: item.iw_number,
      date: format_date(item.record_date, "dd mmmm yyyy"),
      payment_date: format_date(item.record_date, "dd mmmm yyyy"),
      title: item.title,
      cost: item.cost,
      total: item.cost,
      change_satang: 0,
    };
    localStorage.setItem("DATA_", JSON.stringify(data_print));
    window.open("/doc/invoice-other", "_blank");
  };

  render() {
    const { data, filter_address_number, data_address, page } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลการใช้น้ำ" />
        
        <div className="body p-3">
          <div className="card border-0 p-3">
            
            {/* หัวข้อ และ ปุ่มเพิ่ม */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h4 className="mb-0"><b>ข้อมูลการออกใบแจ้งหนี้อื่นๆ</b></h4>
              <button className="btn btn-outline-primary px-4 mx-1" onClick={() => window.location.href = "/record-bill"}>ย้อนกลับ</button>
            </div>

            {/* ค้นหาและตัวกรอง */}
            {view_r && (
              <div className="d-flex align-items-center mb-3">
                <Select
                  className="bg-contain border-0 select-search wpx-200 mx-1"
                  styles={select_style}
                  options={data_address}
                  value={filter_address_number}
                  onChange={(e) => this.setState({ filter_address_number: e })}
                />
                <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>ค้นหา</button>
                <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>รีเซ็ท</button>
              </div>
            )}

            {/* ตาราง */}
            <div className="table-responsive">
              <table className="table table-borderless table-striped text-nowrap">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th className="text-center">เลขที่ใบแจ้งหนี้</th>
                    <th className="text-center">ชื่อ</th>
                    <th className="text-center">ชื่อหน่วยงาน</th>
                    <th className="text-center">ที่อยู่</th>
                    <th className="text-left">วันที่บันทึก</th>
                    <th className="text-center">รายการ</th>
                    <th className="text-center">รวมเป็นเงิน</th>
                    <th className="text-center">พิมพ์ใบเสร็จ</th>
                  </tr>
                </thead>
                <tbody>
                  {(!data || data.data.length === 0) ? (
                    <tr><td colSpan={8} className="text-center">ไม่มีข้อมูล</td></tr>
                  ) : (
                    data.data.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{item.iw_number || "-"}</td>
                        <td className="text-start text-nowrap">{item.full_name || "-"}</td>
                        <td className="text-start text-nowrap">{item.agency_name || "-"}</td>
                        <td className="text-start text-nowrap">{item.address_number || "-"}</td>
                        <td className="text-center">{item.record_date ? format_date(item.record_date, "dd/mm/yyyy") : "-"}</td>
                        <td className="text-start text-nowrap">{item.title || "-"}</td>
                        <td className="text-right">{item.cost ? toFixed(item.cost) : "0.00"}</td>
                        <td className="text-center">
                          <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-inline-flex align-items-center justify-content-center m-0 pointer" onClick={() => this.printReceipt(item)}>
                            <i className="icon text-primary">&#xf02f;</i>
                          </label>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {data?.data?.length > 0 && (
              <div className="d-flex justify-content-between align-items-center w-100 mt-2">
                <label>แสดง {data.end_index} รายการ จาก {data.count} รายการ</label>
                <Pagination
                  count={data.page_number}
                  page={page}
                  color="primary"
                  showFirstButton showLastButton
                  onChange={(e, value) => this.setState({ page: value }, this.GetAll)}
                />
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }
}